import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { PaginatedRailsDataObjects } from 'models/service';
import type { TodoDataObject } from '../types/service';

type TodoRequestParams = {
  date?: string;
  featured?: boolean;
} & CursorPaginationRailsParams;

export const getTodos = async ({ config }: ConfigRequest<TodoRequestParams>) =>
  apiClient.get<
    PaginatedRailsDataObjects<TodoDataObject>,
    ApiClientResponse<PaginatedRailsDataObjects<TodoDataObject>>
  >(routes.todos.get, config);
